// @flow
import { 
  UPDATE_CHART_DATA, 
  UPDATE_LIST_DATA,
  UPDATE_PAST_EARNINGS,
  UPDATE_EARNINGS_STATUS
} from '../../actions/earnings'
import type {
  UPDATE_CHART_DATA_TYPE,
  UPDATE_LIST_DATA_TYPE,
  UPDATE_PAST_EARNINGS_TYPE,
  UPDATE_EARNINGS_STATUS_TYPE
} from '../../actions/earnings'

type State = {
  earningsByDate: Object[],
  upcomingEarningsTargets: Object[],
  pastEarningsTargets: Object[],
  isFetching: boolean,
  error: null | string
}

const initialState: State = {
  earningsByDate: [],
  upcomingEarningsTargets: [],
  pastEarningsTargets: [],
  isFetching: true,
  error: null
}

type Action = 
  | UPDATE_CHART_DATA_TYPE
  | UPDATE_LIST_DATA_TYPE
  | UPDATE_PAST_EARNINGS_TYPE
  | UPDATE_EARNINGS_STATUS_TYPE

export default function earningsReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case UPDATE_CHART_DATA: {
      const { earningsByDate } = action.payload
      return {
        ...state,
        earningsByDate
      }
    }
    case UPDATE_LIST_DATA: {
      const { upcomingEarningsTargets } = action.payload
      return {
        ...state,
        upcomingEarningsTargets
      }
    }
    case UPDATE_PAST_EARNINGS: {
      const { pastEarningsTargets } = action.payload
      return {
        ...state,
        pastEarningsTargets
      }
    }
    case UPDATE_EARNINGS_STATUS: {
      const { isFetching, error } = action.payload
      return {
        ...state,
        isFetching,
        error
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/earnings/index.js